/*
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-28 11:12:00
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-02-16 14:38:15
 * @FilePath: \HIT_BX_INSURER_W\src\utils\platform.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

let platformName = '' // 设置平台名称  luobei则显示萝北登录 ,不填写则默认登录

export default platformName



// WEBPACK FOOTER //
// ./src/utils/platform.js